import React, {useState} from "react";
import {Form, Table, Input, Button, message, Row} from "antd";
import {ColumnsType} from "antd/es/table";

interface DataType {
  key: React.Key;
  name: string;
  age: number;
}
interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  dataIndex: string;
  title: any;
  record: DataType;
  index: number;
  type: string;
  remove: Function;
}
const TableFormList = () => {
  const [dataSource, setDataSource] = useState<DataType[]>([
    {
      key: 0,
      name: "Edward King 0",
      age: "30",
    },
    {
      key: 1,
      name: "Edward King 1",
      age: "32",
    },
  ]);
  // const columns = [
  //   {
  //     title: "name",
  //     dataIndex: "name",
  //     type: "input",
  //     onCell: (record: DataType, rowIndex: number) => ({
  //       index: rowIndex,
  //       type: "input",
  //       title: "name",
  //       dataIndex: "name",
  //     }),
  //   },
  //   {
  //     title: "age",
  //     dataIndex: "age",
  //     type: "input",
  //     onCell: (record: DataType, rowIndex: number) => ({
  //       index: rowIndex,
  //       type: "input",
  //       title: "age",
  //       dataIndex: "age",
  //     }),
  //   },
  //   {
  //     title: "action",
  //     dataIndex: "action",
  //     type: "",
  //     onCell: (record: DataType, rowIndex: number) => ({
  //       index: rowIndex,
  //       dataIndex: "action",
  //       type: "action",
  //     }),
  //   },
  // ];

  const EditTableCell: React.FC<EditableCellProps> = ({
    dataIndex,
    title,
    type,
    index,
    record,
    remove,
    ...restProps
  }) => {
    // console.log(restProps);
    return (
      <td {...restProps}>
        {title}
        {/* {index} */}
        {/* {dataIndex} */}
        <Form.Item name={[index, dataIndex]}>
          {type == "input" ? <Input></Input> : <></>}
          {type == "action" ? (
            <Button
              onClick={() => {
                message.success("remove");
                remove();
              }}
            >
              Xóa
            </Button>
          ) : (
            <></>
          )}
        </Form.Item>
      </td>
    );
  };
  const EditTableCellHeader = ({add, ...props}) => {
    return (
      <th>
        {props.children[1] == "action" ? (
          <Button onClick={add}>Thêm</Button>
        ) : (
          <>{props.children[1]}</>
        )}
      </th>
    );
  };
  const [form] = Form.useForm();
  const onFinish = values => {
    // console.log(values);
  };
  const data: DataType[] = [];
  for (let i = 0; i < 100; i++) {
    data.push({
      key: i,
      name: `Edward King ${i}`,
      age: 32,
    });
  }
  const columns: ColumnsType<DataType> = [
    {
      title: "Name",
      dataIndex: "name",
      width: 250,
      render: (text, _, index) => _.age,
    },
    {
      title: "Age",
      dataIndex: "age",
      width: 150,
    },
    {
      title: "Address",
      dataIndex: "address",
      width: 1000,
    },
  ];
  return (
    <div>
      <Form form={form} onFinish={onFinish}>
        <Table
          columns={columns}
          dataSource={dataSource}
          scroll={{x: 1300}}
        ></Table>
      </Form>
    </div>
  );
};
export default TableFormList;
